module.exports = __webpack_public_path__ + "img/icon-nossos-valores-674f04b6.png";